﻿import { SERVER_ERR } from './MOCK';
/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS, HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { _throw } from 'rxjs/observable/throw';
import {TIPOS, DROGAS, ENTES, PENDIENTES, RESPONSABLES, ASIGNADOS, MATRICULADO, VENTAS, DOWNLOAD_CERT} from './MOCK';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/materialize';
import 'rxjs/add/operator/dematerialize';

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {

    constructor(private http: HttpClient) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        const testUser = { id: 1, username: 'test', password: 'test', firstName: 'Test', lastName: 'User' };
        const matriculadoMock = MATRICULADO;
        const ventaMock = VENTAS;

        // wrap in delayed observable to simulate server api call
        return of(null).mergeMap(() => {
            // authenticate
            if (request.url.endsWith('/jwt/login') && request.method === 'POST') {
                if (request.body.usuario === testUser.username) {
                    // if login details are valid return 200 OK with a fake jwt token
                    return of(new HttpResponse({ status: 200, body: { token: 'fake-jwt-token' } }));
                } else {
                    // else return 400 bad request
                    return _throw('Username or password is incorrect');
                }
            }

            // get users
            if (request.url.endsWith('/api/v1/ventas?rangoRegistros=1..20') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                if (request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: ventaMock }));
                } else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

             if (request.url.endsWith('/api/v1/tiposcertificados') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(TIPOS) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                } else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/certificados') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(PENDIENTES) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/entes') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(ENTES) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                 else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/drogas') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(DROGAS) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                 else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/responsables') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(RESPONSABLES) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                 else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/certificadosasignados') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(ASIGNADOS) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                 else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/certificadosasignados') && request.method === 'POST') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                console.log(request.body);
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(ASIGNADOS) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/certificados') && request.method === 'POST') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                console.log(request.body);
                let error = false;
                if (!error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: JSON.parse(PENDIENTES) }));
                }
                else if (error && request.headers.get('Authorization') === 'fake-jwt-token') {
                    return _throw(new HttpErrorResponse({ status: 400, error: JSON.parse(SERVER_ERR) }));
                }
                else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/matriculados') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                if (request.headers.get('Authorization') === 'fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: matriculadoMock }));
                } else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            if (request.url.endsWith('/api/v1/imagenes/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE1OTk3NjM2NzcsIm5vbmNlIjoiTWZveGp0WloiLCJwYWRyZSI6OTEwMzAwMTUsImluc3RhbmNpYSI6MTAwMDAwMDAyfQ.MKjT9_KkOXlC9DV1pSKBmEwt1yvWHpA8cRN-xl-5jsE') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is
                // implemented server side in a real application
                if (request.headers.get('Authorization') === 'fake-jwt-token') {
                    let header = new HttpHeaders({'Content-Type': 'image/jpeg'});
                    return of(new HttpResponse({ status: 200, body: DOWNLOAD_CERT, headers: header }));
                } else {
                    // return 401 not authorised if token is null or invalid
                    return _throw('Unauthorised');
                }
            }

            // pass through any requests not handled above
            return next.handle(request);
        })
            // call materialize and dematerialize to ensure delay
            // even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
            .materialize()
            .delay(500)
            .dematerialize();
    }
}

export let fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
};
